/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordishnameplaceholder4Inputs */

const en_menueditordishnameplaceholder4 = /** @type {(inputs: Menueditordishnameplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name of the dish`)
};

const de_menueditordishnameplaceholder4 = /** @type {(inputs: Menueditordishnameplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Gerichts`)
};

/**
* | output |
* | --- |
* | "Name of the dish" |
*
* @param {Menueditordishnameplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordishnameplaceholder4 = /** @type {((inputs?: Menueditordishnameplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordishnameplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordishnameplaceholder4(inputs)
	return de_menueditordishnameplaceholder4(inputs)
});
export { menueditordishnameplaceholder4 as "menuEditorDishNamePlaceholder" }